import React, { Component } from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import strings from '../../locales/';

class FileUpload extends Component {
  constructor(props, context) {
    super(props, context);
    var value = props.value;
    var fileLinks = props.fileLinks;
    try {
      value = JSON.parse(value);
      fileLinks = JSON.parse(fileLinks);
    } catch (e) {
      value=null;
      fileLinks=null;
    }

    this.state = { value: value, fileLinks: fileLinks };
  }

  componentWillReceiveProps(nextProps) {
    var value;
    if(nextProps.value!=null) {
      try {
        value = JSON.parse(nextProps.value);
      } catch (e) {
        value=null;
      }
      this.state.value = value;
    }
    var fileLinks;
    if(nextProps.fileLinks!=null) {
      try {
        fileLinks = JSON.parse(nextProps.fileLinks);
      } catch (e) {
        fileLinks=null;
      }
      this.state.fileLinks = fileLinks;
    }
  }

  downloadFile(endpoint, name) {
    this.props.getTaskFile(endpoint, name);
  }

  render() {
    var input = (
      <div className="form-control-wrapper">
        <FormControl
          id={this.props.inputId}
          name={this.props.inputId}
          type="file"
          onChange={this.props.handleOnChange}
          multiple
        />
      </div>
    );
    var readOnly = null;

    if(this.props.readOnly) {
      input=null;
    }

    if(this.state.value && this.state.value.length>0) {
      readOnly = (
        <p className="formOnlyReadData">
          {this.state.value.map( (item,i) => {
            return (
              <a
                key={`file-link-${i}`}
                onClick={(function(){this.downloadFile(this.state.fileLinks[i], item.value)}).bind(this)}
                className="task_file_link"
              >
                {strings.tasks_manager.taskform["download"].toUpperCase() + " " + (i+1)}
              </a>
            );
          })}
        </p>
      );
    }
    else if(this.props.readOnly && (this.state.value == null || this.state.value.length==0)) {
      readOnly = (
        <p className="formOnlyReadData">{strings.tasks_manager.taskform["fileNotUploaded"]}</p>
      );
    }

    return (
      <div id={this.props.id} className={this.props.className + (this.props.error ? " invalidInput" :"")}>
        <FormGroup>
          <ControlLabel>
            {this.props.label}
            {(this.props.required && !this.props.readOnly) && (<span className="required">(*)</span>)}
          </ControlLabel>
          {readOnly}
          {input}
        </FormGroup>
        {this.props.error && (<span className={"required-message"}>{this.props.error}</span>)}
      </div>
    );
  }
}

FileUpload.propTypes = {};

export default FileUpload;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/fileUpload.jsx